module.exports = [{
      plugin: require('/Users/brendenniedermeyer/CodeRepos/calling-card/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-136002182-1","head":false,"respectDNT":true},
    },{
      plugin: require('/Users/brendenniedermeyer/CodeRepos/calling-card/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
